import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideListFilter = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2 5h20M6 12h12m-9 7h6"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideListFilter);
const Memo = memo(ForwardRef);
export default Memo;
